import api from './api';

const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  getRecentActivities: async (limit = 10) => {
    const response = await api.get(`/dashboard/recent?limit=${limit}`);
    return response.data;
  }
};

export default dashboardService;